import { atomWithKey as atom } from "./atomWithKey";
import { ShuttleStateType } from "../Types/Types/Shuttle/ShuttleType";

export const isAddShuttleAtom = atom<boolean>({
    key: "isAddShuttleAtom",
    default: false,
});

export const outboundShuttleState = atom<ShuttleStateType>({
    key: 'outboundShuttleState',
    default: {
        originFrom: '',
        originTo: '',
        destinationFrom: '',
        destinationTo: '',
        date: null,
        calc: '',
        passengers: {},
        originOfferId: '',
        destinationOfferId: '',
        originEdit: false,
        destinationEdit: false,
        originOptions: [],
        destinationOptions: [],
        originShuttleTime: '',
        destinationShuttleTime: '',
        originChecked: false,
        destinationChecked: false
    },
});

export const inboundShuttleState = atom<ShuttleStateType>({
    key: 'inboundShuttleState',
    default: {
        originFrom: '',
        originTo: '',
        destinationFrom: '',
        destinationTo: '',
        date: null,
        calc: '',
        passengers: {},
        originOfferId: '',
        destinationOfferId: '',
        originEdit: false,
        destinationEdit: false,
        originOptions: [],
        destinationOptions: [],
        originShuttleTime: '',
        destinationShuttleTime: '',
        originChecked: true,
        destinationChecked: true
    },
});

export const trainShuttleBookingAtom = atom<boolean>({
    key: "trainShuttleBookingAtom",
    default: false
});